import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ChartNoDataOverlay = () => {
	const { t } = useTranslation("common");
	return (
		<Stack
			sx={{
				position: "absolute",
				inset: 0,
				alignItems: "center",
				justifyContent: "center",
				pointerEvents: "none",
			}}
		>
			<Stack spacing={1} alignItems="center">
				<Stack direction="row" spacing={1}>
					<Stack width={42} height={16} borderRadius={8} bgcolor="secondary.main" />
					<Stack width={82} height={16} borderRadius={8} border="2px solid" borderColor="primary.main" />
				</Stack>

				<Stack direction="row" spacing={1}>
					<Stack width={82} height={14} borderRadius={8} bgcolor="primary.main" />
					<Stack width={42} height={14} borderRadius={8} bgcolor="secondary.main" />
				</Stack>

				<Stack direction="row" spacing={1}>
					<Stack width={82} height={14} borderRadius={8} border="2px solid" borderColor="secondary.main" />
					<Stack width={42} height={14} borderRadius={8} border="2px solid" borderColor="secondary.main" />
				</Stack>

				<Stack direction="row" spacing={1}>
					<Stack width={42} height={14} borderRadius={8} bgcolor="primary.main" />
					<Stack width={82} height={14} borderRadius={8} bgcolor="secondary.main" />
				</Stack>

				<Typography variant="body2" pt={1}>
					{t("no data")}
				</Typography>
			</Stack>
		</Stack>
	);
};
